import script from "./AddCreditPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddCreditPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddCreditPage.vue?vue&type=style&index=0&id=7937312c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7937312c"]])

export default __exports__